module.exports = __webpack_public_path__ + "static/bfp_slide_students-9296647c755e41d5ac5c2429948a1d4b.jpg";